import expressLogo from '../assets/express.png'
import nodeLogo from '../assets/node.png'
import reactLogo from '../assets/react.png'
import mongoLogo from '../assets/mongo.png'
import cplusplusLogo from '../assets/cplusplus.png'
const Skills = () => {
    return ( 
        <div className="skills">
            <h2>SKILLS</h2>
            <div className="container">
                <div className="skill skill1"><img src={mongoLogo} alt="Logo of mongodb" /><span>MONGO DB</span></div>
                <div className="skill skill2"><img src={expressLogo} alt="Logo of express.js" /><span>EXPRESS JS</span></div>
                <div className="skill skill3"><img src={reactLogo} alt="Logo of react.js" /><span>REACT JS</span></div>
                <div className="skill skill4"><img src={nodeLogo} alt="Logo of node.js" /><span>NODE JS</span></div>
                <div className="skill skill5"><img src={cplusplusLogo} alt="Logo of c++" /><span>C++</span></div>
            </div>
        </div>
     );
}
 
export default Skills;